<template>
  <PrintPageLandscape
    :page-number="pageNumber"
    :page-count="pageCount"
    :background-image-url="'/img/short_teaser/short_teaser_start_bg.png'"
  >
    <template #header>
      <div class="short-teaser-start__header">
        <div class="short-teaser-start__logoLink">
          <img
            class="short-teaser-start__logoImage"
            src="/img/short_teaser/short_teaser_logo.png"
            :alt="$t('shortTeaserPrintLogoAlt')"
          />
        </div>
      </div>
    </template>

    <div v-if="project" class="short-teaser-start__main" :data-project-number="project.number">
      <div class="short-teaser-start__card">
        <h1 class="short-teaser-start__customerName">
          {{ this.project.employerProjectNumber }}
        </h1>
        <p class="short-teaser-start__projectCaption">
          {{ $t('shortTeaserPrintCoverProjectLabel', { number: project.number }) }}
        </p>
      </div>
    </div>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';

export default {
  name: 'ShortTeaserPrintPage1',

  components: {
    PrintPageLandscape,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  computed: {},
};
</script>
